import React from 'react';
import { Home, Calendar, Trophy, DollarSign, User, Image as ImageIcon } from 'lucide-react';

interface MobileNavProps {
  currentTab: string;
  onNavigate: (tab: string) => void;
  isOrganizer: boolean;
  onOpenCreateMatch: () => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({
  currentTab,
  onNavigate,
  isOrganizer,
  onOpenCreateMatch
}) => {
  const navItems = [
    { id: 'home', label: 'Matchday', icon: Home },
    { id: 'matches', label: 'Fixtures', icon: Calendar },
    { id: 'media', label: 'Media', icon: ImageIcon },
    { id: 'leaderboard', label: 'Stats', icon: Trophy },
    { id: 'payments', label: 'Ledger', icon: DollarSign },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  return (
    <div className="md:hidden fixed bottom-2 left-2 right-2 z-40 pb-[env(safe-area-inset-bottom)]">
      <div className="bg-[#0f1412]/95 backdrop-blur-md border border-slate-800 rounded-2xl px-1 py-1 shadow-2xl flex justify-around items-center max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentTab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onNavigate(item.id)}
              className={`flex flex-col items-center justify-center py-1 px-1.5 rounded-xl transition touch-manipulation min-w-[50px] ${
                isActive 
                  ? 'text-orange-400 font-extrabold' 
                  : 'text-slate-400 hover:text-slate-200 font-medium active:text-white'
              }`}
            >
              <div className={`p-1 rounded-xl transition ${isActive ? 'bg-orange-500/15 text-orange-400 border border-orange-500/30' : ''}`}>
                <Icon className="w-4 h-4" />
              </div>
              <span className="text-[9px] font-bold mt-0.5 tracking-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

